// extracted by mini-css-extract-plugin
export default {"fieldContain":"BField-module_fieldContain_cd2c6b26","fieldWrap":"BField-module_fieldWrap_c5784e12","fieldTitle":"BField-module_fieldTitle_f95d3ff1"};